import { render } from "./operat.vue?vue&type=template&id=7880aa21&scoped=true&ts=true"
import script from "./operat.vue?vue&type=script&lang=ts"
export * from "./operat.vue?vue&type=script&lang=ts"

import "./operat.vue?vue&type=style&index=0&id=7880aa21&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7880aa21"]])

export default __exports__